'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "KeyboardKey": "Polaris-KeyboardKey",
  "small": "Polaris-KeyboardKey--small"
};

exports.default = styles;
